/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useRef, useState } from 'react'
import { FormikProps } from 'formik'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'
import { Address } from 'models/account'
import { useAppSelector } from 'store/hooks'
import { DomainContact } from 'helpers/utils'

import ContactDetailsForm from 'containers/shop/domains/form/contactDetailsForm'
import ContactSelector from 'containers/shop/domains/contactSelector'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    domain: any,
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function ContactDetailsLightbox({ domain, status, close }: Props) {
    const formRef = useRef<FormikProps<Address>>(null)
    const { appSession: { authenticated } } = useAppSelector((state) => state.app)
    const [template, setTemplate] = useState<'contact' | 'selector'>('selector')
    const [prefillValues, setPrefillValues] = useState(DomainContact)

    const renderTemplate = () => {
        if (template === 'selector' && authenticated) {
            return (
                <ContactSelector
                    initialValues={DomainContact}
                    setPrefillValues={setPrefillValues}
                    setTemplate={setTemplate}
                />
            )
        }

        return (
            <ContactDetailsForm
                domain={domain}
                form={formRef}
                prefillValues={prefillValues}
                mode={'adding'}
                close={close}
            />
        )
    }

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            title={'Domain Contact Details'}
            content={renderTemplate()}
            conditions={{ state: status, action: () => close() }}
            actions={[
                {
                    label: 'Back',
                    color: 'flat',
                    func: () => {
                        if (template === 'selector') {
                            close()
                        } else {
                            setTemplate('selector')
                        }
                    }
                },
                {
                    label: 'Add',
                    color: 'primary',
                    type: 'submit',
                    form: 'contactDetailsForm'
                }
            ]}
        />
    )
}
